import { Inject, Injectable } from "@angular/core"
import { Functions, getFunctions, httpsCallableData } from "@angular/fire/functions"
import { Observable } from "rxjs"

// export const apiserver = (path, data=null):Observable<any> =>{
//   // return httpsCallableData(getFunctions(undefined, 'europe-west1'), path, { timeout: 60_000 })(data)
//   return httpsCallableData(getFunctions(), path, { timeout: 60_000 })(data)
// }

@Injectable({
  providedIn: 'root'
})
export class ApiServerService {
  functions:Functions;
  constructor(@Inject('FIREBASE_REGION') public FIREBASE_REGION: string){
    this.functions = getFunctions(undefined, FIREBASE_REGION);

  }

  call = (path, data=null):Observable<any> =>{
    return httpsCallableData(this.functions, path, { timeout: 60_000 })(data)
  }


  search = (options: SearchModel | Array<SearchModel>) =>{
    const query = Array.isArray(options)? {queries:options} : options; 
    return this.call('api/search', query);
  }

  getIp = () => this.call('api/get/ip');

}


export interface SearchModel {
  index: string;
  body: Object
}